import React, {Component} from "react";
import { withRouter } from 'react-router-dom'
import axios from 'axios';
import Fingerprintjs2 from 'fingerprintjs2';
import Helmet from 'react-helmet';

const initialState={
  google: false,
  yahoo: false,
  line: false,
  fingerPrint: '',
  errorMap: null,
  loading: false,
  ready: false,
  initFlg: true,
  tabChangeFlg: false
}

class SNSSetting extends Component {
  state = initialState;

  componentDidMount() {
    // SNS連携参照API
    this.drawing(this.props.params.ERROR_MESSAGE);

    // フィンガープリント取得
	  let options = {excludes: {userAgent: true, enumerateDevices: true, pixelRatio: true, doNotTrack: true, fontsFlash: true}};
	  Fingerprintjs2.getV18( options, (result)=>{
		  this.setState({ fingerPrint: result });
	  });

  }

  // 画面表示処理（初期、解除後再表示）
  drawing = (queryErrorMessage) => {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    try{

      axios
        .post( process.env.REACT_APP_URL_CO_SC_API_SNS_AUTHN,{},
            {headers: {'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                      'Cache-Control': 'no-store',
                      'Pragma': 'no-cache'}}
          )
        .then( response => {

          // SNS認証連携情報リスト
          const snsSiteIdList = response.data.snsauthnlist;

          let snsSiteRelation = {
            google: false,
            yahoo: false,
            line: false
          };

          for(let i of snsSiteIdList){
            if(i.snsSiteId===process.env.REACT_APP_SNSID_GOOGLE){
              snsSiteRelation.google = true;
            }
            if(i.snsSiteId===process.env.REACT_APP_SNSID_YAHOO){
              snsSiteRelation.yahoo = true;
            }
            if(i.snsSiteId===process.env.REACT_APP_SNSID_LINE){
              snsSiteRelation.line = true;
            }
          }

          this.setState({
            // クエリパラメータにエラーメッセージがある場合付与
            errorMap:{ ERROR: queryErrorMessage ? queryErrorMessage : "" },
            google: snsSiteRelation.google,
            yahoo: snsSiteRelation.yahoo,
            line: snsSiteRelation.line,
            loading: false,
            ready: true
          });

          if (this.state.initFlg) {
            // 「GA計測用データレイヤースクリプト追加処理」を呼出す
            window.addDataLayerScript('jmbauth_sns_alignment');
            window.JLJS_dialog.setup();
            this.setState({
              initFlg: false
            });
          }
        })
        .catch( error => {
          if ( error.response ) {
            if( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }else if( error.response.status === 401 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }else if( error.response.status === 500 ) {
              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }else{
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }
          }else {
            this.setState({ errorMap:
              { ERROR: messageList.snsSetting.M024_errorMessage001 },
              loading: false
            });
          }
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        });

    }catch(err){
      this.setState({ errorMap:
        { ERROR: messageList.snsSetting.M024_errorMessage001 },
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    }finally{
    }
  }

  // SNS連携処理（login前処理をAUTH_TYPE=AUTH_SOCIAL_JOINで呼出す）
  cooperateBtn = async (snsid) => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_snsrelation_b", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    const messageauth = process.env.REACT_APP_MESSAGE_AUTH;
    const authenticated = process.env.REACT_APP_CLIENT_SERVER_URL + process.env.REACT_APP_AUTHENTICATED_PATH;
    const siteid   = process.env.REACT_APP_SITE_ID;
    const authtype = process.env.REACT_APP_AUTH_TYPE_JOIN;
    const fingerPrint = this.state.fingerPrint;
    const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    try {
      // tidクリア
      document.cookie = String(`${process.env.REACT_APP_COOKIE_KEY_TID}=;max-age=0;domain=${cookieDomain};path=${process.env.REACT_APP_COOKIE_PATH};`);

      // パラメータ作成
      const params = new URLSearchParams();
      params.append('AUTH_TYPE', authtype);
      params.append('SITE_ID', siteid);
      params.append('MESSAGE_AUTH', messageauth);
      params.append('AUTHENTICATED', authenticated);
      params.append('snsid', snsid);
      params.append('Fingerprint', fingerPrint);

      // カスタムヘッダーを付与
      const headers = {'auth-request-approval': '',
                      'accept-language': window.changeLang(sessionStorage.getItem("lang")),
                      'Cache-Control': 'no-store',
                      'Pragma': 'no-cache'};

      // ローカルストレージに画面デザイン、画面表示言語を設定する
      localStorage.setItem('design',sessionStorage.getItem('design'));
      localStorage.setItem('lang',sessionStorage.getItem('lang'));

      // ローディング開始
      this.setState({ loading: true });

      // 認証要求URL生成
      const requestUrl = process.env.REACT_APP_URL_CO_SC_API_LOGIN;

      // 認証要求
      axios
        .post( requestUrl, params, {headers:headers} )
        .then( response => {
          const resultCode    = response.data.resultCode;
          const authType      = response.data.authType;
          const authenticated = response.data.authenticated;
          const error_message = response.data.error_message;
          if (resultCode){
            // ログイン画面表示 or 次認証あり
            if (resultCode==='CO-SC0001' || resultCode==='CO-SC0002'){
              if (authType){
                if(authType==='AUTH_SOCIAL_JOIN'){
                  const redirecturi = response.data.redirecturi;
                  // アクションのレポート作成を行うため次画面遷移を1秒遅延させる
                  setTimeout(() => {
                    if(snsid === 'line'){
                      this.setState({
                        loading: false,
                        tabChangeFlg: true
                      });
                    }
                    window.location.href = redirecturi;
                  },1000);
                }
                else{
                  // エラー
                  this.setState({ errorMap:
                    { ERROR: messageList.snsSetting.M024_errorMessage001 },
                    loading: false
                  });
                  // エラーメッセージ表示領域に遷移する
                  window.location="#JS_error";
                }
              }
              else{
                this.setState({ errorMap:
                  { ERROR: messageList.snsSetting.M024_errorMessage001 },
                  loading: false
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";
              }
            }
            // 全認証終了
            else if (resultCode==='CO-SC0003'){
              if (authenticated){
                // アクションのレポート作成を行うため次画面遷移を1秒遅延させる
                setTimeout(() => {
                  window.location.href = authenticated;
                },1000);
              }
              else{
                this.setState({ errorMap:
                  { ERROR: messageList.snsSetting.M024_errorMessage001 },
                  loading: false
                });
                // エラーメッセージ表示領域に遷移する
                window.location="#JS_error";
              }
            }
            // CO-AT5005が返却された場合
            else if (resultCode==='CO-AT5005'){
              // 通常システムエラーメッセージを表示する
              this.setState({ errorMap:
                { ERROR: messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
            else{
              if (error_message){
                this.setState({ errorMap: { ERROR: error_message },
                                loading: false
                                });
              }
              else{
                this.setState({ errorMap:
                  { ERROR: messageList.snsSetting.M024_errorMessage001 },
                  loading: false
                });
              }
              // エラーメッセージ表示領域に遷移する
              window.location="#JS_error";
            }
          }
          else{
            this.setState({ errorMap:
              { ERROR: messageList.snsSetting.M024_errorMessage001 },
              loading: false
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.snsSetting.M024_errorMessage001 },
              loading: false
            });
          }
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        })
    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.snsSetting.M024_errorMessage001 },
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    } finally {
    }
  }

  // [解除]ボタン押下時処理
  releaseBtn = async (site) => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_snsrelation_b", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    try{
      // ローディング開始
      this.setState({ loading: true });

      // SNS連携削除API
      axios
        .delete( process.env.REACT_APP_URL_CO_SC_API_SNS_DELETE,
          {data: {snsSiteId: site},
          headers: {'accept-language': window.changeLang(sessionStorage.getItem("lang")),
          'Cache-Control': 'no-store',
          'Pragma': 'no-cache'}}
        )
        .then( response => {
          window.JLJS_dialog.closeDialog();
          this.drawing('');
        })
        .catch( error => {
          if ( error.response ) {
            if ( error.response.status === 400 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }
            else if ( error.response.status === 401 ) {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }
            else if ( error.response.status === 500 ) {
              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({ errorMap:
                { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.snsSetting.M024_errorMessage001 },
                loading: false
              });
            }
          }
          else {
            this.setState({ errorMap:
              { ERROR: messageList.snsSetting.M024_errorMessage001 },
              loading: false
            });
          }
          // 解除dialogを閉じる
          window.JLJS_dialog.closeDialog();
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        });

    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.snsSetting.M024_errorMessage001 },
        loading: false
      });
      // 解除dialogを閉じる
      window.JLJS_dialog.closeDialog();
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
    } finally {
    }
  }

  // 画面をクローズする
  close = e => {
    window.open('about:blank','_self').close();
  }

  //表示
  render(){

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    //紐付け情報画面
    return(
      <section className="content">

        {/* ブラウザタイトル */}
        <Helmet
          title={messageList.snsSetting.M001_browserTitle} >
        </Helmet>

        { // Loadingモーダル表示
          this.state.loading &&
          <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
        }

        { // LINEタブ遷移モーダル表示
          this.state.tabChangeFlg &&
          <div id="tabChange" className="tab-change-modal">
            <span className="tab-change-message">
              リダイレクトしています…<br></br>
              終了後は画面を閉じてください<br></br>
              <br></br>
              Redirecting…<br></br>
              Please close this screen when finished.
            </span>
          </div>
        }

        {/* 画面タイトル表示部 */}
        <div className="ds-heading ds-heading--lg">
          <h1 className="ds-heading__title">{messageList.snsSetting.M002_pageTitle}</h1>
        </div>

        <div className="contentInner">
          {/* ガイド表示部 */}
          <p className="ds-text">{messageList.snsSetting.M003_guideMessage001}<br/>{messageList.snsSetting.M004_guideMessage002}</p>
          <a href={messageList.snsSetting.M029_noticeUrl001} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
            {messageList.snsSetting.M005_guideMessage003}&nbsp;
            <span className="ds-textLink__icon">
              <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.snsSetting.M008_newWindowIcon}>
                <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
              </svg>
            </span>
          </a>
          <p className="ds-text">{messageList.snsSetting.M006_guideMessage004}</p>
          <a href={messageList.snsSetting.M029_noticeUrl002} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
            {messageList.snsSetting.M007_guideMessage005}&nbsp;
            <span className="ds-textLink__icon">
              <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.snsSetting.M008_newWindowIcon}>
                <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
              </svg>
            </span>
          </a>

          <div id="JS_error">
          { // エラーメッセージ表示
          (this.state.errorMap && this.state.errorMap.ERROR) &&
            <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
              <div className="ds-inlineNote__details">
                <div className="ds-inlineNote__summary">
                  <h2 className="ds-inlineNote__heading">
                    <span className="ds-inlineNote__headingIcon">
                      <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.snsSetting.M009_errorIconText}>
                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                      </svg>
                    </span>
                    <span className="ds-inlineNote__headingLabel">{messageList.snsSetting.M010_errorBoxTitle}</span>
                  </h2>
                </div>
                <div className="ds-inlineNote__content">
                  <p className="ds-text">{this.state.errorMap.ERROR}</p>
                </div>
              </div>
            </div>/* /ds-inlineNote */
          }
          </div>

          {/* 画面項目表示部 */}
          { this.state.ready &&
            <ul className="listLinkage">
              {/* Google */}
              <li className="listLinkage__item">
                <div className="listLinkage__logo">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/logo_google.png`} id="WA_snsLogo-1" alt={messageList.snsSetting.M011_snsGoogle}/>
                </div>
                <div className={"listLinkage__status" + (this.state.google ? " is-active" : "")}>
                  {this.state.google ? messageList.snsSetting.M014_linked : messageList.snsSetting.M013_nolinked}
                </div>
                <div className="listLinkage__action">
                  {!this.state.google &&
                  <div className="ds-button ds-button--primary">
                    <button className="ds-button__trigger" type="button" aria-describedby="WA_snsLogo-1"
                      onClick={() => this.cooperateBtn(process.env.REACT_APP_SNSID_GOOGLE)}>
                      <span className="ds-button__label">{messageList.snsSetting.M015_cooperate}</span>
                    </button>
                  </div>}
                  {this.state.google &&
                  <div className="ds-button ds-button--tertiary">
                    <button className="ds-button__trigger JS_dialogBtn" type="button"
                      aria-haspopup="dialog" aria-controls="WA_modal-1" aria-describedby="WA_snsLogo-1">
                      <span className="ds-button__label">{messageList.snsSetting.M016_release}</span>
                    </button>
                  </div>}
                </div>
              </li>{/* /Google */}

              {/* Yahoo! JAPAN */}
              <li className="listLinkage__item">
                <div className="listLinkage__logo">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/logo_yahoo.png`} id="WA_snsLogo-2" alt={messageList.snsSetting.M012_snsYahoo}/>
                </div>
                <div className={"listLinkage__status" + (this.state.yahoo ? " is-active" : "")}>
                  {this.state.yahoo ? messageList.snsSetting.M014_linked : messageList.snsSetting.M013_nolinked}
                </div>
                <div className="listLinkage__action">
                  {!this.state.yahoo &&
                  <div className="ds-button ds-button--primary">
                    <button className="ds-button__trigger" type="button" aria-describedby="WA_snsLogo-2"
                      onClick={() => this.cooperateBtn(process.env.REACT_APP_SNSID_YAHOO)}>
                      <span className="ds-button__label">{messageList.snsSetting.M015_cooperate}</span>
                    </button>
                  </div>}
                  {this.state.yahoo &&
                  <div className="ds-button ds-button--tertiary">
                    <button className="ds-button__trigger JS_dialogBtn" type="button"
                      aria-haspopup="dialog" aria-controls="WA_modal-2" aria-describedby="WA_snsLogo-2">
                      <span className="ds-button__label">{messageList.snsSetting.M016_release}</span>
                    </button>
                  </div>}
                </div>
              </li>{/* /Yahoo! JAPAN */}

              {/* LINE */}
              <li className="listLinkage__item">
                <div className="listLinkage__logo">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/logo_line.png`} id="WA_snsLogo-3" alt={messageList.snsSetting.M027_snsLine}/>
                </div>
                <div className={"listLinkage__status" + (this.state.line ? " is-active" : "")}>
                  {this.state.line ? messageList.snsSetting.M014_linked : messageList.snsSetting.M013_nolinked}
                </div>
                <div className="listLinkage__action">
                  {!this.state.line &&
                  <div className="ds-button ds-button--primary">
                    <button className="ds-button__trigger" type="button" aria-describedby="WA_snsLogo-3"
                      onClick={() => this.cooperateBtn(process.env.REACT_APP_SNSID_LINE)}>
                      <span className="ds-button__label">{messageList.snsSetting.M015_cooperate}</span>
                    </button>
                  </div>}
                  {this.state.line &&
                  <div className="ds-button ds-button--tertiary">
                    <button className="ds-button__trigger JS_dialogBtn" type="button"
                      aria-haspopup="dialog" aria-controls="WA_modal-3" aria-describedby="WA_snsLogo-3">
                      <span className="ds-button__label">{messageList.snsSetting.M016_release}</span>
                    </button>
                  </div>}
                </div>
              </li>{/* /LINE */}
            </ul>
          }

          {/* 操作ボタン表示部 */}
          <div className="buttonLayout">
            <div className="buttonWrap buttonWrap--left">
              <div className="ds-button ds-button--tertiary ds-button--large">
                <button className="ds-button__trigger" type="button" onClick={this.close}>
                  <span className="ds-button__label">{messageList.snsSetting.M017_close}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 案内表示部 */}
        <div className="contentInner">
          <div className="ds-heading ds-heading--sm">
            <h2 className="ds-heading__title">{messageList.snsSetting.M022_notices}</h2>
          </div>
          <ul className="ds-listText ds-listText--md">
            <li className="ds-listText__item">{messageList.snsSetting.M023_notice001}</li>
            <li className="ds-listText__item">{messageList.snsSetting.M025_notice002}{messageList.snsSetting.M026_notice003}</li>
          </ul>
        </div>

        {/* Google連携解除確認ダイアログ */}
        <div id="WA_modal-1" className="ds-dialog JS_dialog" role="dialog" aria-modal="true" aria-labelledby="WA_modal-title-1" tabIndex="-1">
          <div className="ds-dialog__inner">
            <div className="ds-dialogPanel JS_dialogPanel">
              <div className="ds-dialogPanel__inner">
                <div className="ds-dialogPanel__hdg ds-heading--sm">
                  <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.snsSetting.M031_dialogAlertIcon}>
                    <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_alert`}></use>
                  </svg>
                  <h2 id="WA_modal-title-1" className="ds-dialogPanel__hdgTxt ds-heading__title">{messageList.snsSetting.M018_dialogTitle001}</h2>
                </div>
                <div className="ds-dialogPanel__bottom">
                  <div className="buttonLayout buttonLayout--split">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--danger">
                        <button className="ds-button__trigger" type="button" onClick={() => this.releaseBtn(process.env.REACT_APP_SNSID_GOOGLE)}>
                          <span className="ds-button__label">{messageList.snsSetting.M020_dialogRelease}</span>
                        </button>
                      </div>
                    </div>
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--tertiary">
                        <button className="ds-button__trigger JS_dialogClose" type="button">
                          <span className="ds-button__label">{messageList.snsSetting.M030_dialogCancel}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" className="ds-dialogPanel__closeBtn JS_dialogClose" aria-label={messageList.snsSetting.M017_close}>
                <svg className="ds-icon" width="16" height="9" aria-hidden="true">
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_close`}></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
        {/* /Google連携解除確認ダイアログ */}

        {/* Yahoo! JAPAN連携解除確認ダイアログ */}
        <div id="WA_modal-2" className="ds-dialog JS_dialog" role="dialog" aria-modal="true" aria-labelledby="WA_modal-title-2" tabIndex="-1">
          <div className="ds-dialog__inner">
            <div className="ds-dialogPanel JS_dialogPanel">
              <div className="ds-dialogPanel__inner">
                <div className="ds-dialogPanel__hdg ds-heading--sm">
                  <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.snsSetting.M031_dialogAlertIcon}>
                    <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_alert`}></use>
                  </svg>
                  <h2 id="WA_modal-title-2" className="ds-dialogPanel__hdgTxt ds-heading__title">{messageList.snsSetting.M019_dialogTitle002}</h2>
                </div>
                <div className="ds-dialogPanel__bottom">
                  <div className="buttonLayout buttonLayout--split">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--danger">
                        <button className="ds-button__trigger" type="button" onClick={() => this.releaseBtn(process.env.REACT_APP_SNSID_YAHOO)}>
                          <span className="ds-button__label">{messageList.snsSetting.M020_dialogRelease}</span>
                        </button>
                      </div>
                    </div>
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--tertiary">
                        <button className="ds-button__trigger JS_dialogClose" type="button">
                          <span className="ds-button__label">{messageList.snsSetting.M030_dialogCancel}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" className="ds-dialogPanel__closeBtn JS_dialogClose" aria-label={messageList.snsSetting.M017_close}>
                <svg className="ds-icon" width="16" height="9" aria-hidden="true">
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_close`}></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
        {/* /Yahoo! JAPAN連携解除確認ダイアログ */}

        {/* LINE連携解除確認ダイアログ */}
        <div id="WA_modal-3" className="ds-dialog JS_dialog" role="dialog" aria-modal="true" aria-labelledby="WA_modal-title-3" tabIndex="-1">
          <div className="ds-dialog__inner">
            <div className="ds-dialogPanel JS_dialogPanel">
              <div className="ds-dialogPanel__inner">
                <div className="ds-dialogPanel__hdg ds-heading--sm">
                  <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.snsSetting.M031_dialogAlertIcon}>
                    <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_alert`}></use>
                  </svg>
                  <h2 id="WA_modal-title-3" className="ds-dialogPanel__hdgTxt ds-heading__title">{messageList.snsSetting.M028_dialogTitle003}</h2>
                </div>
                <div className="ds-dialogPanel__bottom">
                  <div className="buttonLayout buttonLayout--split">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--danger">
                        <button className="ds-button__trigger" type="button" onClick={() => this.releaseBtn(process.env.REACT_APP_SNSID_LINE)}>
                          <span className="ds-button__label">{messageList.snsSetting.M020_dialogRelease}</span>
                        </button>
                      </div>
                    </div>
                    <div className="buttonWrap buttonWrap--left">
                      <div className="ds-button ds-button--tertiary">
                        <button className="ds-button__trigger JS_dialogClose" type="button">
                          <span className="ds-button__label">{messageList.snsSetting.M030_dialogCancel}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button" className="ds-dialogPanel__closeBtn JS_dialogClose" aria-label={messageList.snsSetting.M017_close}>
                <svg className="ds-icon" width="16" height="9" aria-hidden="true">
                  <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_close`}></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
        {/* /LINE連携解除確認ダイアログ */}

     </section>
    );
  }
}

export default withRouter(SNSSetting)
